import CodiceFiscale from "codice-fiscale-js";
import moment from "moment";

export const normalizeCfValue = (value) =>
  value == null ? "" : String(value).toUpperCase().replace(/\s+/g, "").trim();

const normalizeBirthplace = (value) => {
  const raw = value == null ? "" : String(value).trim();
  if (!raw) {
    return { birthplace: "", province: undefined };
  }

  const codeMatch = raw.match(/\b([A-Za-z]\d{3})\b/);
  if (codeMatch) {
    return { birthplace: codeMatch[1].toUpperCase(), province: undefined };
  }

  const provinceMatch = raw.match(/\(([A-Za-z]{2})\)\s*$/);
  const province = provinceMatch?.[1]?.toUpperCase();
  const birthplace = provinceMatch
    ? raw.slice(0, provinceMatch.index).trim()
    : raw;

  return { birthplace, province };
};

const normalizeGender = (value) => {
  if (value === 1 || value === "1" || value === "M" || value === "Maschio") {
    return "M";
  }
  if (value === 2 || value === "2" || value === "F" || value === "Femmina") {
    return "F";
  }
  return null;
};

const parseBirthDate = (value) => {
  const date = moment(value, [moment.ISO_8601, "YYYY-MM-DD"], true);
  if (!date.isValid()) {
    return null;
  }
  return {
    day: date.date(),
    month: date.month() + 1,
    year: date.year(),
  };
};

export const buildExpectedCodiceFiscale = (worker = {}) => {
  const name = worker.Nome == null ? "" : String(worker.Nome).trim();
  const surname = worker.Cognome == null ? "" : String(worker.Cognome).trim();
  const gender = normalizeGender(worker.Sesso);
  const birthDate = parseBirthDate(worker.DataDiNascita);
  const birth = normalizeBirthplace(worker.LuogoDiNascita);

  if (!name || !surname || !gender || !birthDate || !birth.birthplace) {
    return { canCompute: false, expectedCf: null };
  }

  const attempts = [];
  if (birth.province) {
    attempts.push({
      birthplace: birth.birthplace,
      birthplaceProvincia: birth.province,
    });
  }
  attempts.push({ birthplace: birth.birthplace });
  if (!birth.province) {
    attempts.push({ birthplace: birth.birthplace, birthplaceProvincia: "EE" });
  }

  for (const attempt of attempts) {
    try {
      const cf = new CodiceFiscale({
        name,
        surname,
        gender,
        ...birthDate,
        ...attempt,
      })
        .toString()
        .toUpperCase();
      return { canCompute: true, expectedCf: cf };
    } catch {
      // try next strategy
    }
  }

  return { canCompute: false, expectedCf: null };
};

export const evaluateCodiceFiscale = (worker = {}) => {
  const cf = normalizeCfValue(worker.CF);
  if (!cf) {
    return { status: "empty", expectedCf: null, message: "" };
  }

  const expected = buildExpectedCodiceFiscale(worker);
  if (!expected.canCompute || !expected.expectedCf) {
    if (!CodiceFiscale.check(cf)) {
      return {
        status: "invalid",
        expectedCf: null,
        message: "Formato CF non valido",
      };
    }
    return { status: "unknown", expectedCf: null, message: "" };
  }

  if (cf === expected.expectedCf) {
    return { status: "verified", expectedCf: expected.expectedCf, message: "" };
  }

  return {
    status: "mismatch",
    expectedCf: expected.expectedCf,
    message: `CF corretto: ${expected.expectedCf}`,
  };
};
